import { PageActionDiscriminator } from 'autogen/swagger/all';
import type { components } from 'autogen/swagger/all/all';
import type { PageActionModel } from '../../PageAction';
import { generateDummyCustomActionModel } from '../CustomAction/shared/helpers';
import { generateDummyLinkActionModel } from '../LinkAction/shared/helpers';

type PageActionTypes = 'CustomActionType' | 'LinkActionType';

export function generateDummyPageActionModel(type: PageActionTypes = 'LinkActionType', url = '#'): PageActionModel {
    switch (type) {
        case 'CustomActionType':
            return { $type: 'CustomActionType', action: generateDummyCustomActionModel() };
        case 'LinkActionType':
            return { $type: 'LinkActionType', action: generateDummyLinkActionModel(url) };
        default:
            return { $type: 'LinkActionType', action: generateDummyLinkActionModel(url) };
    }
}

export function guardIsPageActionOfTypeLinkAction(pageAction?: PageActionModel) {
    if (!pageAction) return undefined;

    return PageActionDiscriminator(
        pageAction,
        (customPageAction) => undefined,
        (linkAction) => linkAction,
        () => undefined
    );
}

export function guardIsPageActionOfTypeCustomAction(pageAction?: PageActionModel) {
    if (!pageAction) return undefined;

    return PageActionDiscriminator(
        pageAction,
        (customPageAction) => customPageAction,
        (linkAction) => undefined,
        () => undefined
    );
}
